import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { SystemStatus } from "./system-status";

const quickLinks = [
  { label: "Support Tickets", path: "/support-system/tickets" },
  { label: "Articles / KB", path: "/support-system/articles-kb" },
  { label: "Categories", path: "/support-system/categories" },
  { label: "Agent Management", path: "/support-system/agents" },
  { label: "Feedback", path: "/support-system/feedback" },
  { label: "LiveChat Feedback", path: "/support-system/live-chat-feedback" },
  { label: "Telegram Setup", path: "/support-system/telegram-setup" },
  { label: "Widget Integration", path: "/support-system/widget-integration" },
];

export default function SupportDashboard() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userStr = localStorage.getItem("supportUser");
    if (userStr) setUser(JSON.parse(userStr));
  }, []);

  const isAdmin = user?.role === "admin" || user?.role === "Super Admin";

  return (
    <div>
      <div className="flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-1">
        <span className="h-px w-6 bg-ginox-green" aria-hidden="true" />
        Overview
      </div>
      <h1 className="font-serif italic text-[36px] leading-[1.05] text-foreground mb-1">
        Support <span className="text-gradient-ginox">Dashboard</span>
      </h1>
      <p className="text-sm text-muted-foreground mb-4">
        {user ? `Welcome back, ${user.name || user.email}` : "Support System Administration"}
      </p>

      {isAdmin && (
        <div className="mb-8">
          <SystemStatus />
        </div>
      )}

      <div className="rounded-lg border border-border/70 bg-card p-6">
        <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-muted-foreground mb-4">
          Quick Actions
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
          {(isAdmin ? quickLinks : quickLinks.slice(0, 1)).map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="rounded-md border border-border/70 bg-white/[0.02] px-4 py-3 text-xs text-muted-foreground hover:bg-white/[0.05] hover:text-foreground transition-colors text-center"
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
